const uploadFileType = "image/png, image/jpeg, video/mp4";

const MAX_SIZE_SCREEN_DETAIL_WIDGET = {
  widthDesktop: 700,
  widgetMobile: 350,
};

const PADDING_WIDGET = {
  desktop: 48,
  mobile: 20,
};

const MAX_SIZE_LOGO = {
  height: 150,
  widthDesktop:
    MAX_SIZE_SCREEN_DETAIL_WIDGET.widthDesktop - PADDING_WIDGET.desktop * 2,
  widgetMobile:
    MAX_SIZE_SCREEN_DETAIL_WIDGET.widgetMobile - PADDING_WIDGET.mobile * 2,
};

const HEIGHT_DRAG_AND_DROP = {
  mobile: 150,
  desktop: 215,
  desktop_i: 250,
};

const REDUNDANT = 39;

const RESOLUTION = {
  minDesktop: 1440,
  tablet: 991,
  midTablet: 768,
  mobile: 576,
};

const DEFAULT_TIMEOUT = 20;

const REGEX = {
  SOCIAL_USERNAME: /^[a-zA-Z0-9._]+$/,
  INSTAGRAM_USERNAME: /^(?!.*?\.{2})[A-Za-z0-9_.]{0,30}$/,
  TWITTER_USERNAME: /^(?=.*[A-Za-z])[A-Za-z0-9_]{1,15}$/,
  TIKTOK_USERNAME: /^[A-Za-z0-9_.-](?!.*?\.{2})[A-Za-z0-9_.-]{1,24}$/,
  PHONE_NUMBER:
    /^(\+\d{1,2}\s?)?1?\-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/, // eslint-disable-line
};

const DEFAULT_FIELD_NAME = {
  email: "emailAddress",
  firstName: "first_Name",
  lastName: "last_Name",
  instagram: "instagram",
  twitter: "twitter",
  tiktok: "tiktok",
  youtube: "youtube",
  phone: "phone",
  mailingAddress: "mailingAddress",
};

const REUSED_FIELD_NAME = {
  instagram: "instagramUsername",
  twitter: "twitterUsername",
  tiktok: "tiktokUsername",
  youtube: "youtubeUsername",
  phone: "phone",
};

const FIELD_NAME = {
  ...REUSED_FIELD_NAME,
  email: "email",
  firstName: "firstName",
  lastName: "lastName",
};

const TYPE_TERM_CONDITION = {
  link: "REDIRECT",
  popupText: "POPUP",
  popupFile: "POPUP_FILE",
  text: "IN_LINE",
};

const SOCIAL_USERNAME = {
  INSTAGRAM: "ig_usr",
  TWITTER: "tw_usr",
  TIKTOK: "tt_usr",
  YOUTUBE: "yt_usr",
};

const TRIMMED_FIELD_NAME = [
  DEFAULT_FIELD_NAME.email,
  REUSED_FIELD_NAME.instagram,
  REUSED_FIELD_NAME.tiktok,
  REUSED_FIELD_NAME.twitter,
  REUSED_FIELD_NAME.youtube,
];

const MAILING_ADDRESS_FIELD_NAME = {
  STREET: "street",
  STATE: "state",
  CITY: "city",
  ZIP_CODE: "zipCode",
};

const UPLOADER_TYPE = {
  UPLOAD: "UPLOAD",
  TIKTOK: "TIKTOK",
  GOOGLE_DRIVE: "GOOGLE_DRIVE",
  YOUTUBE: "YOUTUBE",
  INSTAGRAM: "INSTAGRAM",
  GOOGLE_PHOTOS: "GOOGLE_PHOTOS",
};

const MAX_RECORDS = 20;
const DEFAULT_PAYLOAD = {
  max_count: MAX_RECORDS,
  cursor: 0,
};

const TIKTOK_STORAGE = {
  REFRESH_TOKEN: "tiktokRefreshToken",
  OPEN_MODAL_AT_FIRST: "openModalAtFirst",
};

const LOCAL_STORAGE = {
  LOCATION: "location",
};

const DEFAULT_WIDGET_ID = 9999;
const DEFAULT_ERROR = `<p>We were unable to process the files you attached.</p><ul><li>Make sure you are uploading support file types and sizes. (See <a href="http://www.entribe.com/uploader-support" title="http://www.entribe.com/uploader-support">www.entribe.com/uploader-support</a> for details)</li><li>Check your internet connection is stable.</li><li>Try refreshing your browser</li></ul>Error Code: Not Available`;
const DEFAULT_GETTING_CHANNEL_ERROR = "Retrieving channel information failed.";
const DEFAULT_GETTING_YOUTUBE_VIDEO_ERROR =
  "Retrieving YouTube video list failed.";

const NONE = 0;
const IN_PROGRESS = 1;
const SUCCEEDED = 2;
const FAILED = 3;
const COMPLETED = 4;
const CANCELLED = 5;
const IN_CAPTURATE = "IN_CAPTURATE";

const MAX_PERCENT = 100;
const BYTE_TO_MB = 1048576;

const TYPE_CUSTOM_FIELD = {
  email: "email",
  instagram: "instagram",
  twitter: "twitter",
  tiktok: "tiktok",
  phone: "phone",
  dropdown: "dropdown",
  shortAnswer: "shortAnswer",
  paragraph: "paragraph",
  mailAddress: "mailAddress",
};

const SELECTION_TYPE = {
  MULTIPLE: "MULTIPLE",
  SINGLE: "SINGLE",
};

const CUSTOM_PROPERTY_TYPE = {
  CONTENT: "CONTENT",
  CREATOR: "CREATOR",
};

const MEDIA_TYPE = {
  VIDEO: "video",
  IMAGE: "image",
};

const URL = {
  UPLOADER_SUPPORT: "https://www.entribe.com/uploader-support",
};

const UNSUPPORTED_FILE = {
  TIFF: "tiff",
};

// application/octet-stream: f4v
// application/vnd.rn-realmedia: rm

const SUPPORTED_FILE = {
  HEIC: "heic",
  HEIF: "heif",
  ACCEPTED:
    "image/*,video/*,.HEIC,.heic,.HEIF,.heif,.webp,.WEBP,.hevc,.HEVC,.mjpeg,.MJPEG,.f4v,.F4V,.m2ts,.M2TS,.m2v,.M2V,.mts,.MTS,.ogv,.OGV,.rm,.RM,.ts,.TS,.wtv,.ppm,.psd,.tga,.vbmp,.xpm,.xcf,.xwd,.ras,.raf,.rw2,.cr2,.dds,.exr,.jp2,.jpe,.jps,.mng,.pam,.pbm,.pcd,.pcx,.pfm,.pgm,.picon,.pnm,.wbmp, .tiff, .TIFF",
  IMAGE: ".HEIC,.heic,.HEIF,.heif",
  VIDEO:
    ".hevc,.HEVC,.mjpeg,.MJPEG,.f4v,.F4V,.m2ts,.M2TS,.m2v,.M2V,.mts,.MTS,.ogv,.OGV,.rm,.RM,.ts,.TS,.wtv,.WTV",
  GOOGLE_PHOTO:
    "image/png,image/jpeg,image/heic,image/heif,image/webp,image/svg+xml,image/tiff,image/gif,image/ppm,image/pds,image/tga,image/vbmp,image/xpm,image/xcf,image/xwd,image/ras,image/pes,image/raf,image/rw2,image/x3f,image/cr2,image/dds,image/exr,image/jp2,image/jpe,image/jps,image/mng,image/pam,image/pbm,image/pcd,image/pcx,image/pfm,image/pgm,image/picon,image/pnm,image/x-icon,image/x-xbitmap",
  GOOGLE_VIDEO:
    ",video/ogg,video/quicktime,video/mp4,video/JPEG,video/webm,video/avi,video/vnd.dlna.mpeg-tts,video/mpeg,application/vnd.rn-realmedia,application/octet-stream",
};

const TEXT = {
  TIMEOUT: "timeout of",
};

const GOOGLE_TRANSLATE = {
  QUERY_STRING: "_x_tr_sl=auto&_x_tr_tl=en&_x_tr_hl=en&_x_tr_pto=wapp",
  SCRIPT_SRC:
    "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit",
  SCRIPT_URL:
    "https://translate.googleapis.com/_/translate_http/_/js/k=translate_http.tr.vi.bigRj1Sa3os.O/d=1/exm=el_conf/ed=1/rs=AN8SPfq-tNA7UX4R0CFlbzksSpi5j5-EOQ/m=el_main",
  TEAMPIXEL_ID: "google_translate_element_teampixel",
};

const LIMIT_ERROR_VARIABLES = {
  PHOTO_PER_UPLOAD: "{{maxPhotoPerUpload}}",
  VIDEO_PER_UPLOAD: "{{maxVideoPerUpload}}",
};

const MEDIA_MAX_DIMENSIONS = {
  W: 16000,
  H: 16000,
};

const ERROR = {
  CODE: "{{Error_Code}}",
};

const DURATION = {
  S_0: 0,
  S_06: 600,
  S_1: 1000,
  S_2: 2000,
  S_3: 3000,
  S_5: 5000,
  S_10: 10000,
};

const TIME = {
  SECONDS: 60,
};

const LIMITATION_ERROR_TYPE = {
  TIMEOUT: "TIMEOUT",
  FILE_SIZE: "FILE_SIZE",
  VIDEO_LENGTH: "VIDEO_LENGTH",
  CANCEL: "CANCELLED",
  FAILED: "FAILED", // API returns error
};

const WIDGET_STATUS = {
  ACTIVE: 0,
  DISABLED: 1,
  CLOSED: 2,
};

const KEYBOARD = {
  ENTER: {
    CODE: 13,
    STR: "Enter",
  },
  TAB: {
    CODE: 13,
    STR: "Tab",
  },
  ESC: {
    CODE: 27,
    STR: "Escape",
  },
  UP: { CODE: 38, STR: "ArrowUp" },
  DOWN: {
    CODE: 40,
    STR: "ArrowDown",
  },
};

const PENDO_TRACKING_TYPE = {
  VISITED: {
    label: "VISITED",
    description: "Uploader Visited",
  },
  VISITED_ID: {
    label: "VISITED_ID",
    description: "Uploader Visited",
  },
  ALL_VISITED: {
    label: "ALL_VISITED",
    description: "All Uploader Visited",
  },
};

const ORG_TYPE = {
  CLIENT: "Client",
};

const DOMAIN = {
  LOCALHOST: "localhost",
  ENTRIBE: "uploadqa.entribe.com",
};

const SCRIPT_TAG = "script_tag";

const PREFIX_CLS = "entribe-uploader";

const SOCIAL_NETWORK_URL = {
  INSTAGRAM: "http://instagram.com/",
  TIKTOK: "http:///tiktok.com/",
  TWITTER: "http://twitter.com/",
  FACEBOOK: "https://www.facebook.com/",
  PINTEREST: "http://pinterest.com/",
};

const SCROLLBAR_WIDTH = 6;

const UIW_ADMISSIONS = {
  DEFAULT_HREF: "?cl=69&c=25",
  REDIRECT_HREF: "/admissions?c=25",
};

const PLACEHOLDER_IN_BASE64 = {
  IMAGE:
    "data:image/png;base64,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",
  VIDEO:
    "data:image/png;base64,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",
};

const CLASS_NAME = {
  THUMBNAIL_WRAPPER: "thumbnail_wrapper",
  TIKTOK_THUMBNAIL_WRAPPER: "tiktok_thumbnail_wrapper",
};

const BRAND_NAME = {
  INKEDIBLES: "Inkedibles",
  REVERE: "Revere",
  TEAM_PIXEL: "TeamPixel",
  GEMINI: "Gemini",
};

const LOCATION_COLLECT_METHOD = {
  COLLECT_WITHOUT_CONSENT: "COLLECT_WITHOUT_CONSENT",
  COLLECT_WITH_CONSENT: "COLLECT_WITH_CONSENT",
  NO_COLLECT: "NO_COLLECT",
};

const COOKIE_NAME = {
  WIDGET_URL: "_wgdG9rZW4n",
};

export const COOKIES_EXPIRES_IN = {
  FIVE_MINUTES: "5",
};

export const STORAGE_NAME = {
  SESSION: {
    CLIENT_ID: "clientId",
    CLIENT_NAME: "clientName",
  },
};

const FONT_FAMILY_FORMAT = [
  { type: ".ttf", format: "truetype" },
  {
    type: ".eot?#",
    format: "embedded-opentype",
  },
  {
    type: ".woff2",
    format: "woff2",
  },
  {
    type: ".woff",
    format: "woff",
  },
  {
    type: ".svg#",
    format: "svg",
  },
];

const SELECTORS = {
  STYLE_CUSTOMIZED_FONT_ID: "styleCustomizedFontId",
  WIDGET_ID: "customizedWidgetId",
};

const FONT_FAMILY_NAME = {
  CUSTOMIZED_FONT: "Customized Font",
};

const FONT_STYLE = {
  ITALIC: "italic",
  NORMAL: "normal",
  OBLIQUE: "oblique",
};

const FONT_WEIGHT = {
  BOLD: "bold",
  NORMAL: "normal",
  B_100: 100,
  B_900: 900,
};

const OTHER_FONT_FORMAT = {
  type: "eot",
};

const PATH_NAME = {
  GEMINI: "gemini",
};

const PLACES_FIELDS = [
  "formatted_address",
  "geometry",
  "types",
  "address_components",
  "place_id",
];

export default { uploadFileType };
export {
  BYTE_TO_MB,
  COMPLETED,
  CUSTOM_PROPERTY_TYPE,
  DEFAULT_ERROR,
  DEFAULT_FIELD_NAME,
  DEFAULT_PAYLOAD,
  DEFAULT_TIMEOUT,
  DEFAULT_WIDGET_ID,
  DOMAIN,
  DURATION,
  ERROR,
  FAILED,
  CANCELLED,
  FIELD_NAME,
  GOOGLE_TRANSLATE,
  HEIGHT_DRAG_AND_DROP,
  IN_PROGRESS,
  KEYBOARD,
  LIMITATION_ERROR_TYPE,
  LIMIT_ERROR_VARIABLES,
  LOCAL_STORAGE,
  MAX_PERCENT,
  MAX_RECORDS,
  MAX_SIZE_LOGO,
  MAX_SIZE_SCREEN_DETAIL_WIDGET,
  MEDIA_TYPE,
  NONE,
  ORG_TYPE,
  PADDING_WIDGET,
  PENDO_TRACKING_TYPE,
  REDUNDANT,
  REGEX,
  RESOLUTION,
  REUSED_FIELD_NAME,
  SCRIPT_TAG,
  SCROLLBAR_WIDTH,
  SELECTION_TYPE,
  SOCIAL_NETWORK_URL,
  SOCIAL_USERNAME,
  SUCCEEDED,
  SUPPORTED_FILE,
  TEXT,
  TIKTOK_STORAGE,
  TIME,
  TRIMMED_FIELD_NAME,
  TYPE_CUSTOM_FIELD,
  TYPE_TERM_CONDITION,
  UIW_ADMISSIONS,
  UNSUPPORTED_FILE,
  UPLOADER_TYPE,
  URL,
  WIDGET_STATUS,
  MAILING_ADDRESS_FIELD_NAME,
  PLACEHOLDER_IN_BASE64,
  CLASS_NAME,
  IN_CAPTURATE,
  BRAND_NAME,
  LOCATION_COLLECT_METHOD,
  DEFAULT_GETTING_CHANNEL_ERROR,
  DEFAULT_GETTING_YOUTUBE_VIDEO_ERROR,
  COOKIE_NAME,
  PREFIX_CLS,
  FONT_FAMILY_FORMAT,
  SELECTORS,
  FONT_FAMILY_NAME,
  FONT_STYLE,
  FONT_WEIGHT,
  OTHER_FONT_FORMAT,
  PATH_NAME,
  PLACES_FIELDS,
  MEDIA_MAX_DIMENSIONS,
};
